import styles from "./Container.module.scss";

export default function Container({ children }: React.PropsWithChildren) {
  return <div className={styles.wrapper}>{children}</div>;
}
